import { Btn, type BtnProps } from './Btn'

export const Tag = ({
  className,
  children,
  weight = 'medium',
  ...props
}: BtnProps) => (
  <Btn
    className={['tag rounded-pill px-3 py-1', className]}
    weight={weight}
    {...props}
  >
    {children}
  </Btn>
)

